module.exports = __webpack_public_path__ + "static/media/meteringbanner.a748d4f7.png";